import { createSurveyStyles } from '@sm/webassets';

type StyleProps = {
  isRTL: boolean;
};

const useSurveyStyles = createSurveyStyles(theme => ({
  pageTitle: {
    color: theme?.titleColor,
    lineHeight: 1.25,
    ...theme?.pageTitle,
    // reset font weight changed by the theme above
    '& strong': {
      fontWeight: 'bold !important',
    },
  },
  questionNumber: ({ isRTL }: StyleProps) => ({
    margin: isRTL ? '0 0 0 0.25em' : '0 0.25em 0 0',
  }),
}));

export default useSurveyStyles;
